import { render, staticRenderFns } from "./ElectricalNbrOfEquipmentsQuestion.vue?vue&type=template&id=dae0b83e&scoped=true"
import script from "./ElectricalNbrOfEquipmentsQuestion.vue?vue&type=script&lang=ts"
export * from "./ElectricalNbrOfEquipmentsQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae0b83e",
  null
  
)

export default component.exports